import styled from 'styled-components'
import { Card } from 'react-bootstrap'

export const RootContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  height: 100vh;
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);
  z-index: 1;
`

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  overflow-x: hidden;
  width: 100%;
  max-width: 100%;
  background: linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%);
`

export const NavbarContainer = styled.div`
  height: 6vh;
  width: 100%;
  flex-shrink: 0;
  position: relative;
  z-index: 1001;
`

export const HeaderContainer = styled.div`
  padding-left: 280px;
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  width: 100%;
  z-index: 1;
  background: transparent;
  position: relative;
  /* Prevent width animation to avoid perceived jiggle */
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  scrollbar-gutter: stable both-edges;

  .sidebar-collapsed & {
    padding-left: 80px;
  }

  /* When no sidebar is present */
  .no-sidebar & {
    padding-left: 0;
  }

  @media (max-width: 768px) {
    padding-left: 80px;
  }
`

export const MainContentContainer = styled.div`
  /* Keep vertical scrollbar space reserved to prevent layout shift when content height changes */
  overflow-y: scroll;
  scrollbar-gutter: stable both-edges;
  overflow-x: hidden;
  padding-left: 280px;
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  background: transparent;
  z-index: 1;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  /* Prevent width animation to avoid perceived jiggle */
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  .sidebar-collapsed & {
    padding-left: 80px;
  }

  /* When no sidebar is present */
  .no-sidebar & {
    padding-left: 0;
  }

  @media (max-width: 768px) {
    padding-left: 80px;
  }
`

export const ProjectCard = styled(Card)`
  background-color: transparent;
  border: none;
  width: 100%;

  .card-header {
    color: white;
    padding: 0;
  }
`
